"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHtmlContents = void 0;
const services_1 = require("../services");
const HtmlToReactParser = require('html-to-react').Parser;
const getHtmlContents = async (url) => {
    try {
        const response = await services_1.API.get({ url });
        const htmlToReactParser = new HtmlToReactParser();
        return htmlToReactParser.parse(response);
    }
    catch (error) {
        throw error;
    }
};
exports.getHtmlContents = getHtmlContents;
//# sourceMappingURL=ApiUtils.js.map